import React, { ChangeEvent, FocusEvent, useState } from "react";
// import styles from "./password.module.scss";
import EyeIcon from "../../icons/EyeIcon";
import HideEyeIcon from "../../icons/HideEyeIcon";
import Lock from "../../icons/Lock";
import styles from "./password.module.scss";
import "./style.scss";

const PasswordField = ({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  autoComplete,
  className,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [placeholdertext, setPlaceholderText] = useState(placeholder);

  return (
    <div className="form-group">
      {label && <label htmlFor="">{label}</label>}
      <div
        className={`input-container d-flex align-items-center input_icon_wrap ${isFocused ? "focused" : ""} ${styles.input_group}`}
      >
        <div className={`input_icon`}>{<Lock />}</div>
        <input
          type={passwordVisible ? "text" : "password"}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur && onBlur(e);
          }}
          onFocus={() => {
            setIsFocused(true);
          }}
          placeholder={placeholder}
          className={`${styles.input_pass} ${className} auth_input`}
          style={{
            borderRight: value && value.length > 0
              ? isFocused
                ? "0px solid #6C5DD3"
                : "0px solid #D8DAE5"
              : isFocused
              ? "1px solid #6C5DD3"
              : "1px solid #D8DAE5",

            borderRadius : value && value.length > 0 ? '8px 0 0 8px'  : '8px'
          }}
          autoComplete="off"
        />
        {value && value.length > 0 && (
          <div
            className={`input-group-append ${
              isFocused ? styles.focused : ""
            } ${className}`}
          >
            <span
              className={styles.info}
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? <HideEyeIcon /> : <EyeIcon />}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordField;
